import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import { EmployeeBiometricDetailsObject } from '../EmployeeBiometricDetailsReportSchema';
import { validateProperty } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import defaultImg from '../../../../../assets/img/bioimg.png'

const screenCode = 'EMPLOYEEBIOMETRICDETAILSREPORT';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});
export function EmployeeBiometricDetailsReport(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState();
    const [errors, setErrors] = useState({});
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [biometricDetailsReport, setBiometricDetailsReport] = useState([]);
    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0"
        }
    );

    const [contentRowNames, setContentRowNames] = useState(["registrationNumber", "employeeName",
        "convertedEmployeeBiometricData", "employeeType", 'isActive'])
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        date: "",
        empType: ""
    })
    const initialContentRowNames = ["registrationNumber", "employeeName", "convertedEmployeeBiometricData", "employeeType", "isActive"];
    const initialCsvHeaders = [
        { label: "Registration Number", value: "registrationNumber" },
        { label: "Employee Name", value: "employeeName" },
        { label: "Employee Type", value: "employeeType" },
        { label: "Status", value: "isActive" },
    ];
    const [csvHeaders, setCsvHeaders] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
    }, []);

    useEffect(() => {
        if (searchForm.groupID != "0") {
            trackPromise(
                getEsatesForDropDown()
            )
        }
    }, [searchForm.groupID]);

    useEffect(() => {
        if (searchForm.estateID != "0") {
            trackPromise(
                GetDivisionForDropDown()
            )
        }
    }, [searchForm.estateID]);

    useEffect(() => {
        if (searchForm.estateID != "0") {
            setBiometricDetailsReport([]);
        }
        setBiometricDetailsReport([]);
    }, [searchForm.estateID]);

    useEffect(() => {
        if (searchForm.divisionID != "0") {
            setBiometricDetailsReport([]);
        }

    }, [searchForm.divisionID]);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEMPLOYEEBIOMETRICDETAILS');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(searchForm.estateID);
        setDivisions(routeList);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            estateID: "0",
            divisionID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            divisionID: target.value,
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, EmployeeBiometricDetailsObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        setBiometricDetailsReport([]);
        getSelectedDropdownValuesForReport(searchForm);
        var reportData = await services.GetEmployeeBiometricDetails(searchForm);
        let rowNames = initialContentRowNames;
        let headerNames = initialCsvHeaders;

        setContentRowNames(rowNames);
        setCsvHeaders(headerNames);
        setBiometricDetailsReport(reportData);
    }

    function createFile() {
        var settings = {
            sheetName: 'Employee Biometric Report',
            fileName: 'Employee Biometric Details Report',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(biometricDetailsReport)
        var newRow1 = {
            registrationNumber: "Group : " + selectedSearchValues.estate,
            employeeName: "Estate : " + selectedSearchValues.estate,
            employeeType: selectedSearchValues.division == undefined ? 'Division :' + ' All Divisions' : 'Division :' + selectedSearchValues.division,
        }
        copyOfCsv.push({}, {}, newRow1)
        xlsx(initialCsvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID]
        })
    }

    function isValidBase64Image(base64String) {
        return base64String.startsWith('data:image/');
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Employee Biometric Details Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => trackPromise(handleSearch(e))}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select fullWidth
                                            id="estateID"
                                            name="estateID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={searchForm.estateID}
                                            onChange={(e) => handleEstateChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="divisionID">Division</InputLabel>
                                        <Select fullWidth
                                            id="divisionID"
                                            name="divisionID"
                                            value={searchForm.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}>
                                            <MenuItem value="0">--All Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={(e) => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>
                            <div hidden={biometricDetailsReport == 0}>
                                <TableContainer component={Paper}>
                                    <Table className={classes.table} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Registration Number</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Name</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Biometric Data</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Employee Type</TableCell>
                                                <TableCell align="center" style={{ fontWeight: "bold" }}>Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {biometricDetailsReport.slice(page * limit, page * limit + limit).map((row, i) => (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row" align="center"> {row.registrationNumber}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.employeeName}</TableCell>
                                                    <TableCell align="center">
                                                        {isValidBase64Image(row.convertedEmployeeBiometricData) ? (
                                                            <img
                                                                src={row.convertedEmployeeBiometricData}
                                                                alt={`${row.employeeName}'s biometric image`}
                                                                style={{ width: 100, height: 100 }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={defaultImg}
                                                                alt="Default placeholder"
                                                                style={{ width: 100, height: 100 }}
                                                            />
                                                        )}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.employeeType}</TableCell>
                                                    <TableCell component="th" scope="row" align="center"> {row.isActive}</TableCell>
                                                </TableRow>
                                            )
                                            )}
                                        </TableBody>
                                        <TableHead>
                                        </TableHead>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={biometricDetailsReport.length}
                                        onChangePage={handlePageChange}
                                        onChangeRowsPerPage={handleLimitChange}
                                        page={page}
                                        rowsPerPage={limit}
                                        rowsPerPageOptions={[5, 10, 25]}
                                    />
                                </TableContainer>
                                <div className="pt-2">
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Employee Biometric Details Report"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"

                                        />}
                                        content={() => componentRef.current}
                                    />
                                </div>
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} data={biometricDetailsReport}
                                        rowNames={contentRowNames} searchData={selectedSearchValues} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

